export enum PostStatusEnum {
  Pending = 'pending',
  Approved = 'approved',
  Declined = 'declined',
  Scheduled = 'scheduled',
}
